import { useCallback, useEffect, useMemo, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { addGlobalMessage, MessageLevel } from '../../../../store/messages'
import { intl } from '../../../../i18n'
import { ValidateAllSingleSheetPropertyValues } from './formValidation'

export const useSubmitButton = (
  submit: () => Promise<void>,
  edited: boolean,
  formModel: object,
  hasValidationErrors: boolean,
  validateAllProperties: ValidateAllSingleSheetPropertyValues
): {
  onClickSubmitButton: () => Promise<void>
  submitButtonIsActive: boolean
} => {
  const dispatch = useDispatch()
  const submitButtonIsActive = useMemo(() => edited, [edited])
  const formModelRef = useRef<object>(formModel)
  useEffect(() => {
    formModelRef.current = formModel
  }, [formModel])
  const onClickSubmitButton = useCallback(async () => {
    if (!submitButtonIsActive) {
      return
    }

    const validationErrors = validateAllProperties(formModelRef.current)
    if (Object.keys(validationErrors).length > 0) {
      dispatch(
        addGlobalMessage({
          type: MessageLevel.WARN,
          title: intl.formatMessage({ id: 'global.warning.businessError' }),
          text: Object.values(validationErrors)
            .flatMap(v =>
              v.validationErrors.map(
                errorMessage => `${v.label} > ${errorMessage}`
              )
            )
            .join('\n'),
        })
      )
      return
    }

    await submit()
  }, [submit, submitButtonIsActive, validateAllProperties, dispatch])

  return {
    onClickSubmitButton,
    submitButtonIsActive,
  }
}
